export default __webpack_public_path__ + "static/step-logo-8099efbbde5f3c30940613bd816c4bf6.png";